'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' });

var Terrain = function Terrain(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Terrain = (0, _pure2.default)(Terrain);
Terrain.muiName = 'SvgIcon';

exports.default = Terrain;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Terrain.js
// module id = 2928
// module chunks = 0